import React from "react";
import {Field, reduxForm} from "redux-form/immutable";
import Button from "../../components/Button";
import FormError from "../../components/forms/FormError";
import FormFieldsTable from "../../components/forms/FormFieldsTable";
import {List, Map} from "immutable";
import DropDownInputField from "../../components/forms/DropDownInputField";
import {formatStatus} from "../../lib/TextFormatter";

const POSSIBLE_REPLACEMENT_REASONS = List([
  "damaged",
  "lost_in_transit",
  "returned_to_sender",
  "taste_issue",
  "visual_defect",
  "wrong_item_sent",
  "missing_items",
  "leaking",
  "other",
])

const POSSIBLE_REPLACEMENT_REASONS_OPTIONS = POSSIBLE_REPLACEMENT_REASONS.map((reason) => {
  return Map({
    value: reason,
    title: formatReplacementReason(reason),
  });
});

export const DEFAULT_REPLACEMENT_REASON = "damaged";

export function formatReplacementReason(reason) {
  return formatStatus(reason);
}


// Form shared between the create replacement order and change replacement reason
const ReplacePackagesForShippingOrderForm = (props) => {
  let {errors, submitLabel, handleSubmit, submit, submitting, showCancel} = props;
  // const createAndSendLabel = submitting ? "Standby..." : "Create replacement and send";
  const createAndReviewLabel = submitting ? "Standby..." : submitLabel;
  
  return (
    <form onSubmit={handleSubmit}>
      <div className="fields">
        <p>{props.message}</p>

        <FormFieldsTable>
          <Field
            label="Replacement reason"
            name="replacementReason"
            component={DropDownInputField}
            data={POSSIBLE_REPLACEMENT_REASONS_OPTIONS}
            serverError={props.errors.replacementReason}
            />
        </FormFieldsTable>
      </div>
      <FormError error={errors._error} />
      <div className="buttons column">
        <Button label={createAndReviewLabel} onClick={submit} active={!submitting} />
        <Button show={showCancel} label="Cancel" primary={false} onClick={props.onCancel} active={!props.processing} />
      </div>
    </form>
  )
}

const ReduxForm = reduxForm({
  form: "ReplacePackagesForShippingOrderForm"
})(ReplacePackagesForShippingOrderForm);

export default ReduxForm;